import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrText from 'client/components/SrText';

import SrModalV2, { MODAL_THEME_STACK } from 'client/components/SrModalV2/SrModalV2';
import SrStepper, { SR_STEPPER_THEME_GREYCLIFF } from 'client/components/SrStepper';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrIcon from 'client/components/SrIcon';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';

class SrTenantScreeningWelcomeModal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit } = this.props;

    return (
      <SrModalV2
        showCloseButton={false}
        contentMaxWidth="555px"
        contentPadding="50px 50px 59px 30px"
        theme={MODAL_THEME_STACK}
      >
        <SrBox margin="4px 15px 0 15px">
          <SrFlex align="center" direction="col">
            <SrIcon className="sr-medium-logo" />
            <SrBox height="26px" />
            <SrText
              font="greycliff"
              weight="800"
              size="26"
              lineHeight="33px"
              align="center"
              width="100%"
              display="block"
            >
              Welcome! Get started screening tenants.
            </SrText>
          </SrFlex>
          <SrBox padding="37px 0 50px">
            <SrStepper
              theme={SR_STEPPER_THEME_GREYCLIFF}
              steps={[
                {
                  title: 'Set Criteria',
                },
                {
                  title: 'Get Link',
                },
                {
                  title: 'Approve',
                },
              ]}
              showNumberStep
            />
          </SrBox>
          <SrButton theme={SR_BUTTON_THEME_ADOBE_GREEN} onClick={onSubmit}>
            Continue
          </SrButton>
        </SrBox>
      </SrModalV2>
    );
  }
}

SrTenantScreeningWelcomeModal.displayName = 'SrTenantScreeningWelcomeModal';

export default SrTenantScreeningWelcomeModal;
